import { produce } from "immer";
import { ActionType, getType } from "typesafe-actions";
import { Action } from "@linkfluence/core/modal/actions";
import { Key, State as LkfState } from "@linkfluence/core/state";

type State = LkfState[Key.Modal];

type Actions = ActionType<typeof Action.open> | ActionType<typeof Action.close>;

const DEFAULT_STATE = {};

export default function reducer(state: State = DEFAULT_STATE, action: Actions) {
  return produce(state, (draft) => {
    switch (action.type) {
      case getType(Action.open):
        draft[action.payload] = true;
        break;
      case getType(Action.close):
        delete draft[action.payload];
        break;
    }
  });
}
